import React from "react";
import TextField from "@mui/material/TextField";

const PeopleInput = ({ onPeopleChange, disabled }) => {
  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value > 0) {
      onPeopleChange(value);
    } else {
      onPeopleChange(null); // Set to null or some other falsy value when not valid
    }
  };

  return (
    <TextField
      type="number"
      required
      disabled={disabled}
      InputProps={{ inputProps: { min: 1 } }} // For the "min" attribute
      onChange={handleChange}
      label="Number of People"
      variant="outlined"
      sx={{
        width: "50%",
        marginTop: "1em",
      }}
    />
  );
};

export default PeopleInput;
